import React from 'react'
import clsx from 'clsx'

export interface InputLabelProps {
  isRightLabel?: boolean
  canWrap?: boolean
  name?: string
  forId?: string
  children: React.ReactNode
}

const InputLabel = ({ isRightLabel, name, forId, children, canWrap }: InputLabelProps) => {
  const isPrimaryLabel = !isRightLabel
  const customClasses = clsx(
    'flex text-sm',
    isPrimaryLabel ? 'font-medium font-size text-[#1c2127] leading-5' : 'font-normal font-size',
    isPrimaryLabel && !canWrap && 'whitespace-nowrap'
  )

  return (
    <label htmlFor={forId || name} className={customClasses}>
      {children}
    </label>
  )
}

export default InputLabel
